import { getCurrentUserStatus, setCurrentUserStatus } from './UserStatusHttpApiClient';
import { StepConfig } from '../../types';
import { History } from 'history';
import { getCurrentUserId } from '@rcm/current-user';

// If one of these is in the URL as a param key, the system will enter test mode and will let the user navigate to all the steps
const testModeUrlActivators = ['test'];

export const syncCurrentStepFromServer = (stepIndex: number, steps: StepConfig[], history: History): void => {
    if (getCurrentUserId() === null) {
        // Redirect to login if not logged in
        window.location.href = '/login?redirect=' + encodeURIComponent(
            window.location.pathname + window.location.search + window.location.hash
        );
    }

    if (isInTestMode()) {
        /**
         * Disable syncing step from server if in test mode so we can
         * navigate strait to deep pages while testing.
         *
         * Note: We may consider removing this test functionality before launch
         */
        return;
    }

    /**
     * If someone tries to skip ahead further than the server says they
     * completed, send them back.
     *
     * If someone arrived here after completing some steps but then they
     * left the site, send them forward to where they were before.
     */
    getCurrentUserStatus(getCurrentUserId()).then((userStatus) => {
        const nextStepIndex = userStatus.completedFinalStep
            ? steps.length - 1 // Important incase they completed training long ago and more steps were added
            : userStatus.highestCompletedStepIndex + 1;
        if (stepIndex !== nextStepIndex) {
            history.push('/step/' + (nextStepIndex));
        }
    });
};

export const incrementStep = async (stepIndex: number, steps, history): Promise<void> => {
    await setCurrentUserStatus(
        getCurrentUserId(),
        {
            completedFinalStep: stepIndex === steps.length - 2,
            highestCompletedStepIndex: stepIndex,
        }
    );
    await setStepIndex(stepIndex + 1, steps, history);
};

export const setStepIndex = async (stepIndex: number, steps, history) => {
    history.push('/step/' + (stepIndex) + (isInTestMode() ? '?' + testModeUrlActivators[0] : ''));
}

export const getMaxClickableStepIndex = () => {
    return isInTestMode() ? Infinity : -1;
}

/**
 * Tells whether we are in test mode or not.
 * 
 * In the future this could be changed from looking at the URL to looking at account type, or allow both for video making.
 */
export const isInTestMode = () => {
    for (const activator of testModeUrlActivators) {
        if (window.location.hash.includes('?' + activator) || window.location.hash.includes('&' + activator)) {
            return true;
        }
    }
    return false;
}